module.exports = __webpack_public_path__ + "img/bill_pay.608f10aa.png";